export default function buildPatchAssignTags({
    apiEndpoint,
    apiTools
}) {
    return async function patchAssignTags(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint + '/assign-tags' }` 
        })
       
        const res = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(args.body)
        });
        return await res.json();
    }
}